import { defineMessages } from 'react-intl';

import { PandoraTypes } from './SourceTypes';

export const messages = defineMessages({
  collectedHeader: {
    id: 'collection.collectedHeader',
    defaultMessage: 'Collected',
  },
  collected: {
    id: 'collection.collected',
    defaultMessage: 'Collected {date}',
  },
  emptyFilterHeaderAll: {
    id: 'collection.emptyFilterHeaderAll',
    defaultMessage:
      'Use search to find stations and podcasts. Look for the ⊕ icon to collect them.',
  },
  emptyFilterHeaderAllT3: {
    id: 'collection.emptyFilterHeaderAllT3',
    defaultMessage:
      'Use search to find something to listen to. Look for the ⊕ icon to collect them.',
  },
  emptyFilterHeaderArtists: {
    id: 'collection.emptyFilterHeaderArtists',
    defaultMessage: 'Use search to find artists. Look for the ⊕ icon to collect their music.',
  },
  emptyFilterHeaderSongs: {
    id: 'collection.emptyFilterHeaderSongs',
    defaultMessage: 'Use search to find songs. Look for the ⊕ icon to collect them.',
  },
  emptyFilterHeaderStations: {
    id: 'collection.emptyFilterHeaderStations',
    defaultMessage: 'Use search to find stations. Look for the ⊕ icon to collect them.',
  },
  emptyFilterHeaderAlbums: {
    id: 'collection.emptyFilterHeaderAlbums',
    defaultMessage: 'Use search to find albums. Look for the ⊕ icon to collect them.',
  },
  emptyFilterHeaderPlaylists: {
    id: 'collection.emptyFilterHeaderPlaylists',
    defaultMessage:
      'Use search to find playlists. Look for the ⊕ icon to collect them or create one of your own.',
  },
  emptyFilterHeaderPodcasts: {
    id: 'collection.emptyFilterHeaderPodcasts',
    defaultMessage: 'Use search to find podcasts. Look for the ⊕ icon to collect them.',
  },
  emptyFilterHeaderEpisodes: {
    id: 'collection.emptyFilterHeaderEpisodes',
    defaultMessage: 'Use search to find episodes. Look for the ⊕ icon to collect them.',
  },
  moreByThisArtist: {
    id: 'collection.moreByThisArtist',
    defaultMessage: 'See more by this artist',
  },
  albumMixedFullyCollectedThirdText: {
    id: 'collection.albumMixedFullyCollectedThirdText',
    defaultMessage: `Album - {num, plural,
      one {# song}
      other {# songs}
    }`,
  },
  albumFullyCollectedThirdText: {
    id: 'collection.albumFullyCollectedThirdText',
    defaultMessage: `{num, plural,
      one {# song}
      other {# songs}
    }`,
  },
  albumPartiallyCollectedThirdText: {
    id: 'collection.albumPartiallyCollectedThirdText',
    defaultMessage: '{num} songs added',
  },
  songThirdText: {
    id: 'collection.songThirdText',
    defaultMessage: 'Song - {duration}',
  },
  createPlaylist: {
    id: 'collection.createPlaylist',
    defaultMessage: 'Create playlist',
  },
  MOST_RECENT_ADDED: {
    id: 'collection.recent',
    defaultMessage: 'Recent',
  },
  ALPHA: {
    id: 'collection.aToZ',
    defaultMessage: 'A-Z',
  },
  MOST_RECENT_MODIFIED: {
    id: 'collection.recentModified',
    defaultMessage: 'Recent',
  },
  RecentlyCollected: {
    id: 'collection.RecentlyCollected',
    defaultMessage: 'Recently Collected',
  },
  shuffleSongs: {
    id: 'collection.shuffleSongs',
    defaultMessage: 'Shuffle all songs',
  },
  station: {
    id: 'collection.station',
    defaultMessage: 'Station',
  },
  stationBy: {
    id: 'collection.stationBy',
    defaultMessage: 'Station by',
  },
  stationByPandora: {
    id: 'collection.stationByPandora',
    defaultMessage: 'Station by Pandora',
  },
  sharedStation: {
    id: 'collection.sharedStation',
    defaultMessage: 'Station by {createdBy}',
  },
  artistViewMusic: {
    id: 'collection.artistViewMusic',
    defaultMessage: 'View added music',
  },
  itemAddedToPlaylist: {
    id: 'collection.itemAddedToPlaylist',
    defaultMessage: 'Item added to {playlistName}',
  },
  songsAddedToPlaylist: {
    id: 'collection.songsAddedToPlaylist',
    defaultMessage: `{num, plural,
      one {A song was}
      other {# songs were}
    } added to {playlistName}`,
  },
  viewPlaylist: {
    id: 'collection.viewPlaylist',
    defaultMessage: 'View Playlist',
  },
  cannotCollectSong: {
    id: 'collection.cannotCollectSong',
    defaultMessage: 'This song can’t currently be collected.',
  },
  cannotCollectAlbum: {
    id: 'collection.cannotCollectAlbum',
    defaultMessage: 'This album can’t currently be collected.',
  },
  cannotPlaylistSong: {
    id: 'collection.cannotPlaylistSong',
    defaultMessage: 'This song can’t currently be added to a playlist.',
  },
  cannotPlaylistAlbum: {
    id: 'collection.cannotPlaylistAlbum',
    defaultMessage: 'This album can’t currently be added to a playlist.',
  },
  searchForStation: {
    id: 't.searchForStation',
    defaultMessage: 'Use search to find something to listen to.',
  },
  podcastUnavailable: {
    id: 't.podcastUnavailable',
    defaultMessage: 'This podcast is currently unavailable.',
  },
  itemAddedToCollection: {
    id: 't.itemAddedToCollection',
    defaultMessage: `{pandoraType, select,
          ${PandoraTypes.ALBUM} {Album}
          ${PandoraTypes.SONG} {Song}
          ${PandoraTypes.PLAYLIST} {Playlist}
          ${PandoraTypes.STATION} {Station}
          ${PandoraTypes.PODCAST} {Podcast}
          ${PandoraTypes.EPISODE} {Episode}
          other {Item}
      } added to your collection`,
  },
  itemRemovedFromCollection: {
    id: 't.itemRemovedFromCollection',
    defaultMessage: `{pandoraType, select,
        ${PandoraTypes.ALBUM} {Album}
        ${PandoraTypes.SONG} {Song}
        ${PandoraTypes.PLAYLIST} {Playlist}
        ${PandoraTypes.STATION} {Station}
        ${PandoraTypes.PODCAST} {Podcast}
        ${PandoraTypes.EPISODE} {Episode}
        other {Item}
    } removed from your collection`,
  },
} as const);

export const MyMusicSorts = Object.freeze({
  RECENT: 'MOST_RECENT_ADDED',
  A_TO_Z: 'ALPHA',
} as const);

export const MyPodcastSorts = Object.freeze({
  RECENTLY_COLLECTED: 'MOST_RECENT_ADDED',
  A_TO_Z: 'ALPHA',
} as const);

export const v7SortingMap = {
  [MyMusicSorts.RECENT]: {
    sortByProperty: 'ADDED_TIME',
    sortByOrder: 'DESC',
  },
  [MyMusicSorts.A_TO_Z]: {
    sortByProperty: 'NAME',
    sortByOrder: 'ASC',
  },
} as const;

export const CollectionActions = {
  ADD_COLLECTION_ITEM: 'ADD_COLLECTION_ITEM',
  REMOVE_COLLECTION_ITEM: 'REMOVE_COLLECTION_ITEM',
  REMOVE_STATION_FROM_COLLECTION: 'REMOVE_STATION_FROM_COLLECTION',
  GET_COLLECTION_SORTED_ITEMS: 'GET_COLLECTION_SORTED_ITEMS',
  SET_COLLECTION_CURRENT_FILTER: 'SET_COLLECTION_CURRENT_FILTER',
  GET_COLLECTION_ITEMS_BY_ARTIST: 'GET_COLLECTION_ITEMS_BY_ARTIST',
  RESET_RELOAD_ARTIST_VIEW: 'RESET_RELOAD_ARTIST_VIEW',
  SET_COLLECTION_CURRENT_FILTER_SORT: 'SET_COLLECTION_CURRENT_FILTER_SORT',
  GET_COLLECTION_VERSION: 'GET_COLLECTION_VERSION',
} as const;

export default CollectionActions;
